// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'condition-critical';

export const Component = () => (
  <path fill='currentColor' d='m1 12.5 5.75-10h11.5l5.75 10-5.75 10H6.75z' />
);

export const viewBox = '0 0 25 25';
